import mitt from "mitt";
import { Title } from "./models/title";
import { Employee } from "./models/employees";
type Events = {
  ChangeTitle: Title | string;
  ChangeUrlPath: string;
  InformationDataDone: string;
  BreakingDataError: { text: string; error: any };
  NonBreakingDataError: { text: string; error: any };
  storeChanged: void;
  updatePools: void;
  employeeCreated: Employee;
  employeeDeleted: void;
  EmploymentUpdated: any;
  updateEmployments: number;
  employmentChanged: any;
  upDatePakAndActualPlan: void;
  loginError: string;
  showSalaryWarningIcon: boolean;
  showChangeRequestWarningIcon: boolean;
  showAbsenceWarningIcon: boolean;
  numberOfPendingAbsenceRequests: number;
};

export enum eEventBus {
  changetitle = "ChangeTitle",
  changeurlpath = "ChangeUrlPath",
  NonBreakingDataError = "NonBreakingDataError",
  BreakingDataError = "BreakingDataError",
  InformationDataDone = "InformationDataDone",
  loginError = "loginError",
  employeeCreated = "employeeCreated"
}

export const EventBus = mitt<Events>();

export type EventBusType = typeof eEventBus;
